import { useCan } from "../../lib/access";
import { useNav, useWs } from "../../lib/nav";

/** M7 round six: "See plans" where a plan lacks a feature (a project's own sending domain). Since 2026-10-05 Billing is only in the column of
 *  those who may buy (DECISIONS "Members in Settings"), so everyone else is told who changes the plan instead of a link to a page that is not
 *  theirs. The plan-gate sentence for automatic replies left with them (2026-10-18). */
export function PlansAction() {
  const nav = useNav(); const { ws } = useWs();
  const to = ws("/settings/billing?plans=1");
  if (!useCan()("billing")) return <>The account owner changes the plan.</>;
  return <a className="ob-link" href={to} onClick={(e) => nav(to, e)}>See plans</a>;
}
